import styled from "styled-components";

export const CardStyle = styled.div`
	background-color: #efefef;
	border-radius: 3px;
	padding: 8px;
`;
